import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-bootstrap';
import DesMiddleRightSide from './DesMiddleRightSide';
import PlaceBlock from './PlaceBlock';
import { lang } from '../../../config/lang';
import destinationApi from '../../../api/destinationApi';
import Pagination from '../../../components/pagination/Pagination';


class DestinationAreaMiddle extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchKey: '',
      typeID: -1,
      arrPlace: [],
      curPage: 1,
      pages: 1,
      destinationID: this.props.id
    }
    this.onChangePage = this.onChangePage.bind(this);
    this.getPlaceByType = this.getPlaceByType.bind(this);
    this.getPlaces = this.getPlaces.bind(this);
    this.onSearchKeyChanged = this.onSearchKeyChanged.bind(this);
    this.PlaceByType = this.PlaceByType.bind(this);
    this.viewAll = this.viewAll.bind(this);

    this.lang = props.language.lang_key;
  }

  componentWillMount() {

  }

  componentDidMount() {
    this.getPlaces();
    window.checkSize();
  }

  componentWillUnmount() {

  }

  componentDidUpdate() {
    window.playVideo();
    window.image();
    window.checkSize();
    if (this.props.position === 'place') {
      window.scrollTop('#place');
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.state.destinationID !== newProps.id) {
      // eslint-disable-next-line
      this.state.destinationID = newProps.id;
      // eslint-disable-next-line
      this.state.curPage = 1;
      // eslint-disable-next-line
      this.state.typeID = -1;
      // eslint-disable-next-line
      this.state.arrPlace = [];
      this.getPlaces();
      window.scrollTop('#root');

    }
    if (this.lang !== newProps.language.lang_key) {
      this.lang = newProps.language.lang_key;
      if (this.state.typeID === -1) {
        this.getPlaces();
      }
      else {
        this.getPlaceByType(this.state.destinationID, this.state.typeID);
      }
    }
  }

  onChangePage(page) {
    if (this.state.typeID === -1) {
      // eslint-disable-next-line
      this.state.curPage = page;
      this.getPlaces();
      window.scrollTop('#place');
    }
    else {
      // eslint-disable-next-line
      this.state.curPage = page;
      this.getPlaceByType(this.state.destinationID, this.state.typeID);
      window.scrollTop('#place');
    }
  }

  getPlaceByType(destinationID, typeID) {
    destinationApi.getPlaceByType(destinationID, typeID, this.state.curPage, this.state.searchKey).then((json) => {
      if (json.status === 200 && json.data) {
        this.setState({
          arrPlace: json.data.data,
          curPage: json.data.currentPage,
          pages: json.data.lastPage
        });
      } else {
        if (json.status === 620) {

        } else {

        }
      }
    });
  }

  getPlaces() {
    // if (this.state.searchKey === '') {
    //   this.setState({
    //     arrPlace: []
    //   })
      
    //   return;
    // }
    destinationApi.getDestinationPlace(this.state.destinationID, this.state.curPage, this.state.searchKey).then((json) => {
      if (json.status === 200 && json.data.total !== 0) {
        this.setState({
          arrPlace: json.data.data,
          curPage: json.data.currentPage,
          pages: json.data.lastPage
        })
        window.contentWayPoint();
      } else {
        if (json.status === 200 && json.data.total === 0) {
          this.setState({
            arrPlace: []
          })
        }
      }
    });

  }

  onSearchKeyChanged(key) {
    // eslint-disable-next-line
    this.state.searchKey = key;
    // eslint-disable-next-line
    this.state.curPage = 1;
    if (this.state.typeID === -1) {
      this.getPlaces();
    }
    else {
      // eslint-disable-next-line
      this.getPlaceByType(this.state.destinationID, this.state.typeID);
    }
  }

  PlaceByType(destinationID, typeID) {
    // eslint-disable-next-line
    this.state.typeID = typeID;
    // eslint-disable-next-line
    this.state.curPage = 1;
    if (this.state.typeID === -1) {
      this.getPlaces();
      window.scrollTop('#place');
    }
    else {
      this.getPlaceByType(this.state.destinationID, this.state.typeID);
      window.scrollTop('#place');
    }
  }

  viewAll() {
    // eslint-disable-next-line
    this.state.typeID = -1;
    // eslint-disable-next-line
    this.state.curPage = 1;
    this.getPlaces();
    window.scrollTop('#place');
  }

  render() {
    var visible = 6;
    if (this.state.arrPlace.length === 0 && this.state.searchKey === "") {
      return (
        <div>

        </div>
      );
    }
    return (
      <section className="ftco-section destination_middle_srv" id="place">
        <div className="container">
          <div className="row mb-5 pb-3">
            <div className="col-lg-12 pr-lg-4 heading-section text-center ftco-animate fadeInUp ftco-animated">
              <h2 className="mb-4">
                {this.props.mainDestinationTitle}
              </h2>
              <p>{this.props.mainDestinationSubTitle}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="col-lg-8 pr-lg-4">
                <div className="row">
                  <div className="col-md-12 ftco-animate" >
                    {
                      this.state.arrPlace.length === 0 ?
                        <div>
                          <h4 className='container'>{lang('no_data')}</h4>
                        </div> :
                        this.state.arrPlace.map((place, key) => {
                          return (
                            <PlaceBlock
                              key={key}
                              destinationID={this.state.destinationID}
                              id={place.id}
                              title={place.title}
                              type={place.type}
                              image={place.media_filename}
                              media_type={place.media_filetype}
                              keyword={this.state.searchKey}
                            />
                          );
                        })
                    }

                  </div>
                </div>

                <section style={{ width: '100%' }}>
                  <div className="container">
                    <div className="row justify-content-center pb-5">
                      <div className="block-27">
                        {
                          this.state.arrPlace.length > 0 &&
                          <Pagination
                            total={this.state.pages}
                            curPage={this.state.curPage}
                            visible={visible}
                            onChangePage={(page) => this.onChangePage(page)}
                          />
                        }
                      </div>
                    </div>
                  </div>
                </section>

              </div>
              <DesMiddleRightSide
                id={this.props.id}
                businesses={this.props.businesses}
                onSearchKeyChanged={(key) => this.onSearchKeyChanged(key)}
                getPlaceByType={(destinationID, typeID) => this.PlaceByType(destinationID, typeID)}
                viewAll={() => this.viewAll()}
                placeCategoriesTitle={this.props.placeCategoriesTitle}
                experienceTitle={this.props.experienceTitle}
              />

            </div>
          </div>
        </div>

      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default connect(mapStateToProps)(DestinationAreaMiddle);